import {
  SetStatusActionStatus,
  SetStatusSnoozePeriod,
} from "@redotech/redo-model/return-flow/action";
import { RuleTypeDetailsProps } from "@redotech/redo-return-ui/flows/rules/multiple-actions";
import { SetStatusState } from "@redotech/redo-return-ui/flows/rules/set-status";
import { LabeledInput } from "@redotech/redo-web/labeled-input";
import { SelectDropdown } from "@redotech/redo-web/select-dropdown";
import { memo } from "react";
import * as selectCss from "../return-flow/select.module.css";

const statusOptions = [
  SetStatusActionStatus.ARCHIVED,
  SetStatusActionStatus.CLOSED,
  SetStatusActionStatus.OPEN,
  SetStatusActionStatus.SNOOZED,
  SetStatusActionStatus.SPAM,
];

const snoozePeriodOptions = [
  SetStatusSnoozePeriod.NEXT_WEEK,
  SetStatusSnoozePeriod.TODAY,
  SetStatusSnoozePeriod.TOMORROW,
  SetStatusSnoozePeriod.WEEKEND,
];

const getSnoozePeriodLabel = (snoozePeriod: SetStatusSnoozePeriod) => {
  switch (snoozePeriod) {
    case SetStatusSnoozePeriod.TODAY:
      return "Later the same day";
    case SetStatusSnoozePeriod.TOMORROW:
      return "The next day";
    case SetStatusSnoozePeriod.WEEKEND:
      return "The next Saturday";
    case SetStatusSnoozePeriod.NEXT_WEEK:
      return "The next Monday";
  }
};

export const SetStatusDetails = memo(function SetStatusDetails({
  state,
  setState,
  disabled,
}: RuleTypeDetailsProps<SetStatusState>) {
  return (
    <>
      <LabeledInput label="Status">
        <SelectDropdown
          disabled={disabled}
          options={statusOptions}
          value={state.status}
          valueChange={(e) => {
            if (e) {
              setState((state) => ({ ...state, status: e }));
            }
          }}
        >
          {(status) => (
            <div className={selectCss.value}>
              <div className={selectCss.title}>{status}</div>
            </div>
          )}
        </SelectDropdown>
      </LabeledInput>
      {state.status === SetStatusActionStatus.SNOOZED && (
        <LabeledInput label="Until">
          <SelectDropdown
            disabled={disabled}
            options={snoozePeriodOptions}
            value={state.snoozePeriod}
            valueChange={(e) => {
              if (e) {
                setState((state) => ({ ...state, snoozePeriod: e }));
              }
            }}
          >
            {(snoozePeriod) => (
              <div className={selectCss.value}>
                <div className={selectCss.title}>
                  {getSnoozePeriodLabel(snoozePeriod)}
                </div>
              </div>
            )}
          </SelectDropdown>
        </LabeledInput>
      )}
    </>
  );
});
